import { render } from "./chatMessage.vue?vue&type=template&id=57c85249&ts=true"
import script from "./chatMessage.vue?vue&type=script&lang=ts"
export * from "./chatMessage.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\projects\\equistasi\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__